
$(document).on('click', '.myBtn3', function(){ 
  //$('.myBtn3').on('click', function(){   
     $('#modal_container .modal_slider').html($('#mymodal_3 .modal_3-content').html());
 $('#modal_container').css("display", "block");
 $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	

$(document).on('click', '.myBtnc', function(){ 

   $('#modal_container .modal_slider').html($('#mymodal_c .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	


$(document).on('click', '.myBtna', function(){ 
 
  $('#modal_container .modal_slider').html($('#mymodal_a .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	


$(document).on('click', '.myBtnb', function(){ 

   $('#modal_container .modal_slider').html($('#mymodal_b .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	


$(document).on('click', '.myBtncr', function(){ 
    
   $('#modal_container .modal_slider').html($('#mymodal_cr .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	


   

$(document).on('click', '.notmyBtn1', function(){ 

   $('#modal_container .modal_slider').html($('.notmymodal_1 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn2', function(){ 

   $('#modal_container .modal_slider').html($('.notmymodal_2 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn3', function(){ 

   $('#modal_container .modal_slider').html($('.notmymodal_3 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn4', function(){ 

   $('#modal_container .modal_slider').html($('.notmymodal_4 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn5', function(){ 

   $('#modal_container .modal_slider').html($('.notmymodal_5 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn6', function(){ 
$('#modal_container .modal_slider').html($('.notmymodal_6 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn7', function(){
 $('#modal_container .modal_slider').html($('.notmymodal_7 .modal_3-content').html());
$('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn8', function(){
$('#modal_container .modal_slider').html($('.notmymodal_8 .modal_3-content').html());
$('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn9', function(){
 $('#modal_container .modal_slider').html($('.notmymodal_9 .modal_3-content').html());
$('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.notmyBtn10', function(){
 $('#modal_container .modal_slider').html($('.notmymodal_10 .modal_3-content').html());
$('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.quickviewbutton', function(){
   var product_handle = $(this).data('handle');
  var product_link ='';
  if (product_handle.includes('products')) {
 product_link=product_handle;
 } else {
 product_link='../products/'+product_handle;
 
}
  jQuery.getJSON('' + product_link + '.js', function (product) {
      var title = product.title;
    var produrl = product.url;
      var type = product.type;
    var variants = product.variants;
    var price = product.price;
    var sku = '';
    var variantid='';
    var VariantCount = $(variants).length;
   $(variants).each(function (i, variant) {
     
     if (i == VariantCount - 1) {
        sku = variant.sku;
       variantid=variant.id;
        price = parseFloat(variant.price / 100).toFixed(2); 
       } else {
       sku = variant.sku;
       variantid=variant.id;
        price = parseFloat(variant.price / 100).toFixed(2); 
        }

      });
    if (price) {
      var fixedprice = price.replace('.', '<sup>')+'</sup>';
    } else {
      var fixedprice = price;
    }
    
    var images = product.images;
      
      var original_price = 0;
      var desc = product.description;
            var imageCount = $(images).length;
var image_embed ='';
      $(images).each(function (i, image) {

        if (i == 0) {
          image_embed = '<div class="modal-product_img"><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        } 

      });
    var simpleoptionstitle =product.metafields;
var textfind = product.title;
    var htmldata = '<span class="closer">CLOSE<span class="close-modal-icon"></span></span><span class="modal_body"><h2>'+product.title+'</h2>';
htmldata =htmldata+ '<div class="modal-product__image-wrap '+simpleoptionstitle+'">'+image_embed+'</div><div class="modal-description" > '+product.description+' </div> <div class="modalsee-view"><div class="modal-see-more">Show More</div><div class="modal-see-less" style="display:none;">Show Less</div></div>';
htmldata =htmldata+ '<div class="grid-item__meta"><div class="modal-item__meta-main col-a"><div class="product-sku regprodsku"><strong>SKU: </strong>'+sku+'</div>';
 htmldata =htmldata+ '<div class="grid-product__price"><span class="grid-product__price--current"><span aria-hidden="true">$'+fixedprice+'</span></span></div></div><div class="modal-item__meta-main col-b">';
  if (product.tags.includes('ATS:disc')) {
    htmldata =htmldata+ '<span class="modal-message-title">Save 10% More on Aromatherapy</span><br><span class="modal-message-body">Mix or match any 4+ crystals/liquids</span>';
  } else {
    htmldata =htmldata+ '<!-- hoop -->';
  }
     htmldata =htmldata+ '</div></div>';
  htmldata =htmldata+ '<div class="modal-action-buttons">';
//if (VariantCount > 1||product.type =="hidefromfeed"||sku=="PX1000") {
    if (!product.tags.includes('AB:inSPAration')&&!product.tags.includes('AB:spazazz')) {
       htmldata =htmldata+ '<a href="'+produrl+'" class="btn btn-full-full">Details Page</a>';
} else if (textfind.includes("~ Mix")) {
  htmldata =htmldata+ '<a href="'+produrl+'" class="btn btn-full-full">Select Products</a>';
  } else {

htmldata =htmldata+ '<div class="product__quantity"><div class="js-qty__wrapper" id="Item--'+variantid+'">';
htmldata =htmldata+ '<input type="text" id="Quantity--'+variantid+'" class="js-qty__num item-quantity" value="1" min="1" aria-label="quantity" pattern="[0-9]*" name="mod-quantity">';
htmldata =htmldata+ '<button type="button" class="js-qty__adjust btn-subtract" aria-label="Reduce item quantity by one"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 64 64"><path class="cls-1" d="M55 32H9"></path></svg></button>';
htmldata =htmldata+ '<button type="button" class="js-qty__adjust btn-add" aria-label="Increase item quantity by one"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 64 64"><path class="cls-1" d="M32 9v46m23-23H9"></path></svg> </button></div></div>';


  // product B


// includes button minus disablement if at minimum or below
var numqty = 1;
  //var clickity = "Shopify.addItem('"+variantid+""', ";
$(document).on('click', '#Item--'+variantid+' .btn-subtract', function(){  

    if ($('#Item--'+variantid+' .item-quantity').val() <= 1) {
      $('#Item--'+variantid+' .btn-subtract').attr('disabled','disabled');

    } else {
     $('#Item--'+variantid+' .btn-subtract').removeAttr('disabled');
    $('#Item--'+variantid+' .item-quantity').val(parseInt($('#Item--'+variantid+' .item-quantity').val()) - 1);   
     numqty = $('#Item--'+variantid+' .item-quantity').val();
 $('.qty--'+variantid).attr('onClick','Shopify.addItem('+variantid+','+numqty+')');
    }
  

});
$(document).on('click', '#Item--'+variantid+' .btn-add', function(){  

    if ($('#Item--'+variantid+' .item-quantity').val() >= 1) {
      
     $('#Item--'+variantid+' .btn-subtract').removeAttr('disabled');
    }
 $('#Item--'+variantid+' .item-quantity').val(parseInt($('#Item--'+variantid+' .item-quantity').val()) + 1); 
  numqty = $('#Item--'+variantid+' .item-quantity').val();
 $('.qty--'+variantid).attr('onClick','Shopify.addItem('+variantid+','+numqty+')');
}); 

  
htmldata =htmldata+ '<button class="btn btn-full-full cardadd qty--'+variantid+'" onClick="Shopify.addItem('+variantid+', '+numqty+');">Add to Cart</button>';

htmldata =htmldata+ '<a href="'+produrl+'" class="btn btn_reverse btn-full-full">Details Page</a>';

  
}
htmldata =htmldata+ '</div>';//modal-action-buttons
    htmldata =htmldata+ '</span><script>alert = function(){};</script><style>.modal-description .dollardeal{display:none;}</style>';
    $('#modal_container .modal_slider').html(htmldata);          

 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});

 
   });
  
   });
  

$(document).on('click', '.cardadd', function(){  

    // Now I will do a get to show the itens from cart
   setTimeout(function() {
   jQuery.getJSON('/cart.js', function(cart) {
        let cartData = cart.items;
        document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
             detail: cartData
        })); 
   });
     $( ".modal_slider" ).animate({
    right:'-300px'
});
 $('#modal_container').fadeOut('slow');
   $('.modal_closer').css("display", "none");  
     $('.cart-link').trigger('click');
   }, 400); 
 });




         $(document).on('click', '#button-agree', function()
{
$('#sc-tc').prop('checked', true);
         });	
$(document).on('click', '.myBtn4', function(){
//$('.myBtn4').on('click', function(){     
 $('#modal_container .modal_slider').html($('#mymodal_4 .modal_4-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.myBtn6', function(){
//$('.myBtn6').on('click', function(){     
 $('#modal_container .modal_slider').html($('#mymodal_6 .modal_4-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	


$(document).on('click', '.myBtn1', function(){
 //$('.myBtn1').on('click', function(){    
   $('#modal_container .modal_slider').html($('#mymodal_1 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
 $( ".modal_slider" ).animate({
    right:'0px'
});
});	
$(document).on('click', '.myBtn2', function(){
//$('.myBtn2').on('click', function(){ 
  $('#modal_container .modal_slider').html($('#mymodal_2 .modal_3-content').html());
 $('#modal_container').css("display", "block");
  $('.modal_closer').css("display", "block");
$( ".modal_slider" ).animate({
    right:'0px'
});
});	

$(document).on('click', '.closer', function(){   

  $( ".modal_slider" ).animate({
    right:'-300px'
});
 $('#modal_container').fadeOut('slow');
$('.modal_closer').css("display", "none");
});	

$(document).ready(function(){ 
$('.modal_slider').on('click', function(e){ 
   // e.stopPropagation();
  });	
 $('.modal_closer').on('click', function(e){   
  $( ".modal_slider" ).animate({
    right:'-300px'
});
 $('#modal_container').fadeOut('slow');
$('.modal_closer').css("display", "none");
});	
  $(document).on('click', '.modal-see-more', function(){

$(".modal-description" ).css("display","block");
 $(".modal-see-more" ).css("display","none");
  $(".modal-see-less" ).css("display","block");
  });	
$(document).on('click', '.modal-see-less', function(){

  $(".modal-description" ).css("display","-webkit-box");
$(".modal-see-less" ).css("display","none");
  $(".modal-see-more" ).css("display","block");
  });	

 


                  });